import { takeEvery, put, call, all, fork } from 'redux-saga/effects';
import { BookingCalendarTypes } from './actionTypes';
import {
  bookingApiSuccess,
  bookingApiFail,
  updateBookingEventSuccess,
  updateBookingEventFail,
  deleteBookingEventSuccess,
  deleteBookingEventFail,
  getBookingCategoriesSuccess,
  getBookingCategoriesFail,
} from './actions';
import {
  getBookingEvents,
  addNewBookingEvent,
  updateBookingEvent,
  deleteBookingEvent,
  getBookingCategories,
} from '../../helpers/fakebackend_helper';

function* fetchBookingEvents() {
  try {
    const response: Promise<any> = yield call(getBookingEvents);
    yield put(bookingApiSuccess(BookingCalendarTypes.GET_EVENTS, response));
  } catch (error) {
    yield put(bookingApiFail(BookingCalendarTypes.GET_EVENTS, error));
  }
}

function* onAddNewBookingEvent({ payload: event }: any) {
  try {
    const response: Promise<any> = yield call(addNewBookingEvent, event);
    yield put(bookingApiSuccess(BookingCalendarTypes.ADD_NEW_EVENT, { ...response }));
  } catch (error) {
    yield put(bookingApiFail(BookingCalendarTypes.ADD_NEW_EVENT, error));
  }
}

function* onUpdateBookingEvent({ payload: event }: any) {
  try {
    const response: Promise<any> = yield call(updateBookingEvent, event);
    yield put(updateBookingEventSuccess(response));
  } catch (error) {
    yield put(updateBookingEventFail(error));
  }
}

function* onDeleteBookingEvent({ payload: event }: any) {
  try {
    const response: Promise<any> = yield call(deleteBookingEvent, event);
    yield put(deleteBookingEventSuccess(response));
  } catch (error) {
    yield put(deleteBookingEventFail(error));
  }
}

function* onGetBookingCategories() {
  try {
    const response: Promise<any> = yield call(getBookingCategories);
    yield put(getBookingCategoriesSuccess(response));
  } catch (error) {
    yield put(getBookingCategoriesFail(error));
  }
}

function* bookingCalendarSaga() {
  yield all([
    fork(function* () {
      yield takeEvery(BookingCalendarTypes.GET_EVENTS, fetchBookingEvents);
    }),
    fork(function* () {
      yield takeEvery(BookingCalendarTypes.ADD_NEW_EVENT, onAddNewBookingEvent);
    }),
    fork(function* () {
      yield takeEvery(BookingCalendarTypes.UPDATE_EVENT, onUpdateBookingEvent);
    }),
    fork(function* () {
      yield takeEvery(BookingCalendarTypes.DELETE_EVENT, onDeleteBookingEvent);
    }),
    fork(function* () {
      yield takeEvery(BookingCalendarTypes.GET_CATEGORIES, onGetBookingCategories);
    }),
  ]);
}

export default bookingCalendarSaga;
